import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { SettingsService } from "../../services/settings.service";

@Injectable()
export class SharePointExistsGuard implements CanActivate {
  constructor(private settingsService: SettingsService, private router: Router) {}
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const id = route.paramMap.get("instance-id");
    const key = route.paramMap.get("sharepoint-id");
    return this.settingsService.get(id).pipe(
      map((data) => {
        const index = data.sharePoint.sharepointConfig.findIndex((item) => item.key === Number(key));
        if (index > -1) {
          return true;
        }
        const errorMessage = "SharePoint connection Id does not exist or is invalid.";
        this.router.navigate(["/", "error"], { queryParams: { detail: errorMessage } });
        return false;
      })
    );
  }
}
